import React from 'react';
import { mergePrismicPreviewData } from 'gatsby-source-prismic';
import { Layout } from '../components';
import { BlogPost as BlogPostBody } from '../components/Blog/BlogPost';

const IS_BROWSER = typeof window !== 'undefined';

export const BlogPost = ({ location, pageContext }) => {
  const { data: staticData, siteName } = pageContext;
  const previewData = IS_BROWSER && window.__PRISMIC_PREVIEW_DATA__;
  const data = mergePrismicPreviewData({ staticData, previewData });
  const { post } = data;
  const { data: postData } = post;
  const { meta_title: metaTitle, meta_description: metaDesc, title, featured, date, content, excerpt } = postData;
  const seo = {
    title: metaTitle.text || `${siteName}`,
    desc: metaDesc.text || excerpt.text,
  };
  return (
    <Layout location={location} seo={seo} bodyClassName="blog-post-body" siteName={siteName}>
      <BlogPostBody image={featured} title={title} content={content} excerpt={excerpt} date={date} />
    </Layout>
  );
};

export default BlogPost;
